import { supportsAirwallexApplePay } from '../plugins/airwallex-apple-pay';

export default {
  data() {
    return { paymentMethods: [] };
  },
  computed: {
    applePayEnabled() {
      return supportsAirwallexApplePay(window.systemCurrency)
        && this.paymentMethods.some((method) => Number(method.id) === 8);
    },
    airwallexWalletSelected() {
      return Number(this.paymentMethod) === 8;
    },
  },
  methods: {
    filterWalletPaymentMethods(methods) {
      return methods.filter((method) => Number(method.id) !== 8
        || supportsAirwallexApplePay(window.systemCurrency));
    },
    async selectAirwallexApplePay(selected) {
      if (![7, 8].includes(Number(this.paymentMethod))) return;
      const paymentTypeId = selected ? 8 : 7;
      if (Number(this.paymentMethod) === paymentTypeId) return;
      const recovery = this.airwallexPaymentRecovery;
      if (recovery) {
        if (!recovery.can_switch_payment_method) return;
        const released = await this.cancelAirwallexCartRecoveryForPaymentSwitch(recovery);
        if (!released) return;
      }
      if (selected) {
        this.saveAsDefaultCard = false;
        this.airwallexPaymentMode = 'useNewCard';
      }
      this.paymentMethod = paymentTypeId;
    },
  },
  watch: {
    paymentMethod(value) {
      if (Number(value) === 8) {
        this.saveAsDefaultCard = false;
        this.airwallexPaymentMode = 'useNewCard';
      }
    },
  },
};
